import React from 'react';

// The constellation/zodiac assets in public/img are flat, single-color
// silhouette PNGs baked in a sky-blue that doesn't match the app theme.
// Render them as a CSS mask instead of a plain <img> so they always pick up
// the brand color (see .mask-icon in web/src/theme/global.scss).
const ConstellationIcon = ({ src, className, style }) => (
  <span
    className={['mask-icon', className].filter(Boolean).join(' ')}
    style={{ WebkitMaskImage: `url(${src})`, maskImage: `url(${src})`, ...style }}
  />
);

export default ConstellationIcon;
